module.exports = __webpack_public_path__ + "media/images/payment/logo_seico-c4e8ac69d1ec4a61780213977d446b48.gif";